
import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {isCrawler} from "../../utils/crawler";

import {Timer} from "../../utils/Timer";
import {Rect} from "../../utils/Rect";

export interface LazyImageProps extends JSX.HTMLAttributes {
	dataSrc: string;
	fit?: boolean;
	cover?: boolean;
	contain?: boolean;
	onload?: any;
}

@element("flipp-lazy-image", "img")
export class LazyImage extends Component<LazyImageProps, {}> {
	@attr dataSrc: string;
	@attr fit: boolean;

	private _scrollDebouncer = new Timer(10,
			this.loadImageIfInViewport, this);

	onAttach() {
		window.addEventListener("scroll", this._handleViewportChange, true);
		window.addEventListener("resize", this._handleViewportChange, true);

		this.loadImageIfInViewport();
	}

	onDetach() {
		this._unbindEvents();
	}

	onRender() {
		this.loadImageIfInViewport();
		this.loadForCrawler();
	}

	private isInViewport() {
		let screenRect = new Rect(0, 0, window.innerWidth, window.innerHeight);
		let boundingRect = this.getBoundingClientRect();

		return Rect.intersects(screenRect, boundingRect);
	}

	private loadImageIfInViewport() {
		if (isCrawler()) {
			return;
		}
		const isDisplayed = this.attached && (this.offsetParent !== null);
		const browser = navigator.userAgent;

		if (isDisplayed && this.isInViewport()) {
			// load the image
			const objectFit = this.style.hasOwnProperty("objectFit") &&
					this.style.hasOwnProperty("objectPosition");

			if (objectFit) {
				this.src = this.dataSrc;
			}
			if (browser.includes("Firefox") || (browser.includes("Trident") || browser.includes("Edge"))) {
				this.src = this.dataSrc;
			}

			this._unbindEvents();
		}
	}

	private _handleViewportChange = (e: Event) => {
		this._scrollDebouncer.reset();
	}

	private _unbindEvents() {
		window.removeEventListener("scroll", this._handleViewportChange, true);
		window.removeEventListener("resize", this._handleViewportChange, true);
	}

	private loadForCrawler() {
		if (isCrawler() && !this.src) {
			this.src = this.dataSrc;
		}
	}
}
